<template>
<div
    class="login-box"
    style="min-height: 873px;"
>
    <div class="box-header with-border">

    </div>
    <div class="login-box-body">
        <h4 class="login-box-msg">{{ $t('INSERT NEW PASSWORD') }}</h4>

        <form v-on:submit.prevent>

            <br>
            <div class="input-group">
                <span class="input-group-addon"><i class="fa fa-eye-slash"></i></span>
                <input
                    type="password"
                    v-model="password"
                    class="form-control"
                    :placeholder="passPlaceholder"
                >
            </div>

            <br>
            <div class="input-group">
                <span class="input-group-addon"><i class="fa fa-eye-slash"></i></span>
                <input
                    type="password"
                    v-model="passwordconfirmation"
                    class="form-control"
                    :placeholder="passPlaceholderConfirmation"
                >
            </div>

            <div class="form-group has-error">
                <label
                    class="control-label"
                    for="inputError"
                >
                    {{ error_message }}
                    </label>
            </div>

            <br>
            <button
                class="btn btn-primary"          
                @click="send"
            >{{ $t('CHANGE') }}</button>
                <router-link
                    to="/"
                    class="btn btn-default"
                >Cancelar</router-link>
        </form>
        <div v-if="loading==true">
            <center>
                <div
                    class="fa fa-circle-o-notch fa-spin text-blue"
                    style="font-size:50px;"
                ></div>
        </center>
    </div>
    </div>

    </div>
</template>


<script>
import axios from "axios";
import swal from 'sweetalert'
export default {
    name: "forgotpassword",
    data() {
        return {
            token: this.$route.params.token,
            password: '',
            passwordconfirmation: '',
            loading: false,
            error_message: '',
            passPlaceholder:this.$t('PLACEHOLDERPASSWORD'),
            passPlaceholderConfirmation:this.$t('PLACEHOLDERVERIFICATIONPASSWORD'),

        };
    },
    methods: {
        async send() {
            try {
                let self= this;
                if((this.password).length > 5){
                    if (this.password != this.passwordconfirmation) {
                    this.error_message = this.$t('PASSWORD_VERIFICATION_THE_SAME')
                } else {
                    this.loading = true;
                    let response = await this.$store.state.services.userService.changePassword({
                        password: this.password,
                        passwordconfirmation: this.passwordconfirmation,
                        token: this.token
                    })
                    console.log({response})
                    this.loading = false;
                    swal({
                        title:this.$t("PASSWORD CHANGER"),
                        text: response.data.message,
                        icon: 'success'
                    }).then(response => {
                        self.$router.push('/');
                    })

                }
                }else{
                    this.error_message= this.$t("PASSWORD_VERIFICATE_LENGTH");
                }
              
            } catch (error) {
                console.log({error})
                this.loading = false;
                 swal({
                        title: this.$t("SOMETHING IS WRONG"),
                        text: error.response.data.error,
                        icon: 'error'
                    })
              
            }

        }
    }
};
</script>



// WEBPACK FOOTER //
// src/components/Users/passwordTokenVerification.vue